export const CREATE_ACTION: string = 'create';
export const DELETE_ACTION: string = 'delete';
export const UPDATE_START_ACTION: string = 'updateStart';
export const UPDATE_END_ACTION: string = 'updateEnd';
export const UPDATE_DAY_ACTION: string = 'updateDay';

export const UPDATE_ACTION: string = 'update';
